import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(3, 4),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: theme.spacing(0.5),
    boxSizing: 'border-box',
  },
  elementsGap: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: `${theme.spacing(2.5)} !important`,
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  resourceRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  resourcesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  trashIcon: {
    color: theme.palette.labraIcon.main,
    cursor: 'pointer',
    paddingTop: theme.spacing(2.25),
    width: '2%',
  },
  widthButton: {
    width: 'fit-content',
    marginBottom: theme.spacing(1),
  },
  border: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: theme.spacing(0.5),
    boxSizing: 'border-box',
  },
  titleWraper: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  alignDescription: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    color: theme.palette.textField.dark,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.25px',
  },
  disabledText: {
    color: theme.palette.select.light,
    opacity: '38%',
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: theme.spacing(2.5),
    letterSpacing: '0.1px',
    width: 'fit-content',
  },
  columnName: {
    width: '36.5%',
  },
  columnDesc: {
    width: '38.5%',
  },
  columnPrice: {
    width: '22%',
  },
  descHeightWidth: {
    width: '38.5%',
    height: theme.spacing(7),
  },
  heading: {
    color: theme.palette.labraText.primary,
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: theme.spacing(3.5),
    paddingBottom: theme.spacing(2),
    width: '98%',
  },
  value: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: theme.spacing(2.5),
    paddingBottom: theme.spacing(2),
  },
  wordWrap: {
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    maxWidth: '100%',
  },
}))
